function escKeyHandler(func) {
  return function(e) {
    if (e.key === `Escape`) {
      func(e)
    }
  }
}

export default {
  bind(el, { value: func }) {
    document.addEventListener(`keyup`, escKeyHandler(func))
  },
  unbind(el, { value: func }) {
    document.removeEventListener(`keyup`, escKeyHandler(func))
  },
}
